import { motion } from "framer-motion";
import { CONFIG } from "@/config";
import { VideoPoster } from "@/components/VideoPoster";

const ease = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal: each sentence slides up from behind its own clip
const RevealLines = ({ text, className, delay = 0, as: Tag = "span" }) => {
  const lines = text.split(/(?<=[.!?])\s+/);
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className="block"
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease, delay: delay + i * 0.14 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const RegistrationGate = ({ onPlay }) => {
  const g = CONFIG.gate;
  return (
    <section className="relative pt-4 pb-20 sm:pt-8" data-testid="registration-gate">
      <div className="max-w-3xl">
        <motion.span
          className="eyebrow"
          initial={{ opacity: 0, x: -12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease }}
          data-testid="gate-badge"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-[#B6F23C] shadow-[0_0_12px_#B6F23C]" />
          {g.badge}
        </motion.span>

        <RevealLines
          as="h1"
          text={g.headline}
          delay={0.15}
          className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.02] text-[#F4F5F2] [&>span:last-child]:italic [&>span:last-child]:font-light [&>span:last-child]:text-[#D9B25F]"
        />

        <motion.p
          className="mt-6 max-w-xl text-base md:text-lg text-[#A3A89E] leading-relaxed"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease, delay: 0.55 }}
          data-testid="gate-subheadline"
        >
          {g.subheadline}
        </motion.p>
      </div>

      <div className="mt-8 sm:mt-10">
        <VideoPoster onPlay={onPlay} />
      </div>
    </section>
  );
};
